module.exports = __webpack_public_path__ + "img/portugal-neoplasm-female.87e5370c.png";